import { createReducer, on, Action } from "@ngrx/store";
import * as LoadingActions from "../actions/loading.action";
import { ILoadingState, initialLoadingState } from "../state/loading.state";

export const loadingReducer = createReducer(
  initialLoadingState,
  on(LoadingActions.showLoadingAction, (state: ILoadingState) => {
    return ({
        ...state,
        hidden: false
      }
    );
  }),
  on(LoadingActions.closeLoadingAction, (state: ILoadingState) => {
    return ({
        ...state,
        hidden: true
      }
    );
  })
);

export function loadingReducers(state: ILoadingState, action: Action) {
  return loadingReducer(state, action);
}
